class TextColumns {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.tc__track');
    this.wrapper = el.querySelector('.tc__track-wrapper');
    this.prevBtn = el.querySelector('.tc__arrow--prev');
    this.nextBtn = el.querySelector('.tc__arrow--next');
    this.current = 0;
    this.isSliderActive = false;
    this.startX = 0;

    // Visible slides on mobile (exclude desktop-only blocks)
    this.slides = Array.from(
      el.querySelectorAll('.tc__block:not(.tc__block--desktop-only)')
    );
    this.total = this.slides.length;

    this._bindArrows();
    this._bindTouch();

    this._resizeHandler = () => this._onResize();
    window.addEventListener('resize', this._resizeHandler);
    this._onResize();
  }

  _isMobile() {
    return window.innerWidth < 750;
  }

  _onResize() {
    if (this._isMobile() && !this.isSliderActive) {
      this._activate();
    } else if (!this._isMobile() && this.isSliderActive) {
      this._deactivate();
    }
  }

  _activate() {
    this.isSliderActive = true;
    this.current = 0;
    gsap.set(this.track, { x: 0 });
    this._updateArrows();
  }

  _deactivate() {
    this.isSliderActive = false;
    gsap.set(this.track, { clearProps: 'x' });
  }

  _bindArrows() {
    if (!this.prevBtn || !this.nextBtn) return;
    this.prevBtn.addEventListener('click', () => this._go(this.current - 1));
    this.nextBtn.addEventListener('click', () => this._go(this.current + 1));
  }

  _bindTouch() {
    this.track.addEventListener('touchstart', (e) => {
      this.startX = e.touches[0].clientX;
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      if (!this.isSliderActive) return;
      const diff = this.startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        this._go(this.current + (diff > 0 ? 1 : -1));
      }
    }, { passive: true });
  }

  _go(index) {
    if (!this.isSliderActive) return;
    this.current = Math.max(0, Math.min(index, this.total - 1));
    const slideWidth = this.slides[0]?.offsetWidth || this.wrapper.offsetWidth;
    gsap.to(this.track, {
      x: -this.current * slideWidth,
      duration: 0.45,
      ease: 'power2.out'
    });
    this._updateArrows();
  }

  _updateArrows() {
    if (!this.prevBtn || !this.nextBtn) return;
    this.prevBtn.disabled = this.current === 0;
    this.nextBtn.disabled = this.current === this.total - 1;
  }

  destroy() {
    window.removeEventListener('resize', this._resizeHandler);
  }
}

function initTextColumns() {
  document.querySelectorAll('.tc').forEach((el) => {
    if (el._tcInstance) el._tcInstance.destroy();
    el._tcInstance = new TextColumns(el);
  });
}

document.addEventListener('DOMContentLoaded', initTextColumns);

document.addEventListener('shopify:section:load', (e) => {
  const el = e.target.querySelector('.tc');
  if (!el) return;
  if (el._tcInstance) el._tcInstance.destroy();
  el._tcInstance = new TextColumns(el);
});
